<template>
  <div>
  <div class="container seg-content general user">
    <section class="home-list">
      <a class="new-button" href="" v-on:click.prevent="createNew">Add New Aparatus</a>
      
      <item-list entity="VideoAparatus" v-if="selectedItem===null" v-on:select="selectedItem=$event" />
      <item-edit entity="VideoAparatus" v-else :item="selectedItem" v-on:save="selectedItem=null" />
    </section>

    
    

    
  </div>
  </div>
</template>
<script>
export default {
  data: ()=>({
    menuOpen: false,
    selectedItem: null,
  }),
  methods: {
    createNew() {
      this.selectedItem={
        id: null,
        title: "",
        showinnav: false,
      };
    },
    toggleMenu() {
      this.menuOpen=!this.menuOpen;
      if (!this.menuOpen)
        this.$refs.mobileMenu.menuSubOpen=null;
    },
    action($event) {
      var actionName="action"+($event.name[0].toUpperCase())+($event.name.substring(1));
      
      this[actionName] && this[actionName]($event);
    },
  },
}
</script>
